"use client";
import ProductCard from "@/components/ProductCard";
import { FormatSubType } from "@/constants/tagular/main";
import { useTypedSearchHits } from "../../hooks/useTypedSearchHits";

function NoResulsProductList() {
  const { items: hits } = useTypedSearchHits();

  return (
    <div className="overflow-x-auto">
      <div className="flex flex-nowrap gap-4 py-4">
        {hits.map((hit) => (
          <div key={hit.uuid} className="flex justify-center">
            <ProductCard
              {...hit}
              className="!w-[300px]"
              location="search-results"
              formatSubtype={FormatSubType.HorizontallyStacked}
              resultLevel="level"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default NoResulsProductList;
